/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetInventoryIdByItemId$Params {
  itemId?: string;
}

export function getInventoryIdByItemId(http: HttpClient, rootUrl: string, params?: GetInventoryIdByItemId$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'inventoryId'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, getInventoryIdByItemId.PATH, 'get');
  if (params) {
    rb.query('itemId', params.itemId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'inventoryId'?: string;
      }>;
    })
  );
}

getInventoryIdByItemId.PATH = '/admin/item/inventoryId';
